import PropTypes from 'prop-types';

import Styles from './Resume.module.scss';
import classNames from 'classnames';
import { getDuration, getDates } from '@hiredigital/lib/helpers/marketingDate';

const ResumeItem = (props) => {
  const { startMonth, startYear, endMonth, endYear } = props;

  return (
    <div className={classNames(props.className, Styles.itemContainer)} style={props.style}>
      <p className={Styles.title}>{props.title}</p>
      <p className={Styles.subtitle}>{props.subtitle}</p>
      <p className={Styles.date}>{`${getDates(
        startMonth,
        startYear,
        endMonth,
        endYear
      )} ${getDuration(startMonth, startYear, endMonth, endYear)}`}</p>
      {props.description && (
        <div
          className={Styles.description}
          dangerouslySetInnerHTML={{
            __html: props.description,
          }}></div>
      )}
    </div>
  );
};

ResumeItem.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  startMonth: PropTypes.number,
  endMonth: PropTypes.number,
  startYear: PropTypes.number,
  endYear: PropTypes.number,
  description: PropTypes.node,
  style: PropTypes.object,
};

export default ResumeItem;
